module.exports = __webpack_public_path__ + "img/diamond-vip.d802791c.svg";